(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
      const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-noor-shop"] && !Shopify.designMode) return;
  try {
      document.querySelectorAll('[data-noor-shop]').forEach((shop) => {
    const slides = Array.from(shop.querySelectorAll('[data-ns-slide]'));
    const cta = shop.querySelector('[data-ns-hero-cta]');
    const time = shop.querySelector('[data-ns-hero-time]');
    const name = shop.querySelector('[data-ns-hero-name]');
    const labels = Array.from(shop.querySelectorAll('.ns-index a'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides.length < 2 || !cta) return;
    let current = 0;
    const showSlide = (index) => {
      current = index;
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === current));
      cta.href = slides[current].dataset.productUrl;
      if (labels[current]) {
        time.textContent = labels[current].querySelector('span').textContent;
        name.textContent = labels[current].querySelector('strong').textContent.trim();
      }
    };
    showSlide(0);
    if (!reducedMotion) window.setInterval(() => showSlide((current + 1) % slides.length), 4800);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-design-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-noor-design-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ndc-track]');
    if (!track) return;
    carousel.querySelectorAll('[data-ndc-action]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = track.querySelector('.ndc__card');
        if (!card) return;
        const direction = button.dataset.ndcAction === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 16), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-features"] && !Shopify.designMode) return;
  try {
    
  const nfHero = document.querySelector('.nf-hero__app');
  if (nfHero) {
    const slides = Array.from(nfHero.querySelectorAll('.nf-hero__slide'));
    const dots = Array.from(nfHero.querySelectorAll('[data-nf-dot]'));
    const status = nfHero.querySelector('.nf-hero__status');
    const template = status ? status.dataset.template : '';
    let index = 0;
    let timer = null;

    const render = () => {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        // Only the visible screen is exposed, so AT announces one image, not three.
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (status && template) {
        status.textContent = template
          .replace('CURRENT', String(index + 1))
          .replace('TOTAL', String(slides.length));
      }
    };

    const stop = () => {
      if (timer) { clearInterval(timer); timer = null; }
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        stop();                       // once a visitor chooses, stop deciding for them
        index = Number(dot.dataset.nfDot);
        render();
      });
    });

    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (slides.length > 1 && !calm.matches) {
      timer = setInterval(() => {
        index = (index + 1) % slides.length;
        render();
      }, 5000);
      nfHero.addEventListener('mouseenter', stop);
      nfHero.addEventListener('focusin', stop);
    }

    render();
  }

  const nfVideoWrap = document.querySelector('.nf-mat-video');
  if (nfVideoWrap) {
    const video = nfVideoWrap.querySelector('video');
    const toggle = nfVideoWrap.querySelector('[data-nf-video]');
    const calmMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const paint = () => {
      const playing = !video.paused;
      toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
      // Two bars while playing, a triangle once paused.
      toggle.querySelector('path').setAttribute('d', playing ? 'M9 5v14M15 5v14' : 'M8 5l11 7-11 7z');
      toggle.querySelector('path').setAttribute('fill', playing ? 'none' : 'currentColor');
    };

    if (calmMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    toggle.addEventListener('click', () => {
      video.paused ? video.play() : video.pause();
    });
    video.addEventListener('play', paint);
    video.addEventListener('pause', paint);
    paint();
  }

  const stage = document.querySelector('[data-nf-stage]');
  if (stage) {
    const spots = Array.from(stage.querySelectorAll('[data-nf-spot]'));
    const closeAll = (except) => {
      spots.forEach((b) => {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        document.getElementById(b.getAttribute('aria-controls')).hidden = true;
      });
    };
    spots.forEach((btn) => {
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        document.getElementById(btn.getAttribute('aria-controls')).hidden = open;
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('click', (e) => { if (!stage.contains(e.target)) closeAll(); });

    // Design switching: swatches choose directly, tapping the mat cycles.
    const img = stage.querySelector('[data-nf-mat]');
    const matBtn = stage.querySelector('[data-nf-cycle]');
    const swatches = Array.from(stage.querySelectorAll('[data-nf-design]'));
    const altTpl = img.dataset.altTemplate || '';
    let current = 0;
    // Warm the cache so the first switch does not flash.
    swatches.slice(1).forEach((b) => { const p = new Image(); p.src = b.dataset.src; });

    const show = (i) => {
      current = (i + swatches.length) % swatches.length;
      const b = swatches[current];
      swatches.forEach((x, k) => x.setAttribute('aria-pressed', k === current ? 'true' : 'false'));
      matBtn.classList.add('is-swapping');
      const done = () => { matBtn.classList.remove('is-swapping'); img.removeEventListener('load', done); };
      img.addEventListener('load', done);
      img.src = b.dataset.src;
      if (altTpl) img.alt = altTpl.replace('DESIGN', b.textContent.trim());
      if (img.complete) done();
    };
    swatches.forEach((b, i) => b.addEventListener('click', () => show(i)));
    matBtn.addEventListener('click', () => show(current + 1));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-research"] && !Shopify.designMode) return;
  try {
    
  const researchSections = document.querySelectorAll('.nr-reveal');
  const researchObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        researchObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  researchSections.forEach((section) => researchObserver.observe(section));

  const heroCarousel = document.querySelector('.nr-hero__carousel');
  const heroSlides = Array.from(document.querySelectorAll('.nr-hero__slide'));
  if (heroCarousel && heroSlides.length > 1) {
    const status = heroCarousel.querySelector('.nr-hero__carousel-status');
    const template = status ? status.dataset.template : '';
    let heroSlideIndex = 0;

    const render = () => {
      heroSlides.forEach((slide, i) => {
        const active = i === heroSlideIndex;
        slide.classList.toggle('is-active', active);
        // Only the visible slide is exposed, so AT announces one image, not five.
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (status && template) {
        status.textContent = template
          .replace('CURRENT', String(heroSlideIndex + 1))
          .replace('TOTAL', String(heroSlides.length));
      }
    };

    const step = (delta) => {
      heroSlideIndex = (heroSlideIndex + delta + heroSlides.length) % heroSlides.length;
      render();
    };

    heroCarousel.querySelectorAll('[data-nr-slide]').forEach((button) => {
      button.addEventListener('click', () => step(button.dataset.nrSlide === 'prev' ? -1 : 1));
    });
    render();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-shop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-noor-shop]').forEach((shop) => {
    const slides = Array.from(shop.querySelectorAll('[data-ns-slide]'));
    const cta = shop.querySelector('[data-ns-hero-cta]');
    const time = shop.querySelector('[data-ns-hero-time]');
    const name = shop.querySelector('[data-ns-hero-name]');
    const labels = Array.from(shop.querySelectorAll('.ns-index a'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides.length < 2 || !cta) return;
    let current = 0;
    const showSlide = (index) => {
      current = index;
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === current));
      cta.href = slides[current].dataset.productUrl;
      if (labels[current]) {
        time.textContent = labels[current].querySelector('span').textContent;
        name.textContent = labels[current].querySelector('strong').textContent.trim();
      }
    };
    showSlide(0);
    if (!reducedMotion) window.setInterval(() => showSlide((current + 1) % slides.length), 4800);
  });

  } catch(e) { console.error(e); }
})();
})();
